<script setup>
import { computed, getCurrentInstance, onMounted, ref } from "vue";
import _ from "lodash";
import { RouterLink } from "vue-router";
import KSASecondaryButton from "../../../../../components/ui-components/button/KSASecondaryButton.vue";
import adminMatchingService from "../../../services/matching/adminMatchingService";
import mypageProposalService from "../../../../user/services/mypage/mypageProposalService";
import { useAlertStore } from "../../../../../stores/alertStore";
import { usePageLoadingStore } from "../../../../../stores/pageLoading";
import MypageProposalContentModal from "../../../../user/views/mypage/proposal/MypageProposalContentModal.vue";
import MyPageResumeModal from "../../../../user/components/modal/mypage/MyPageResumeModal.vue";
const { $alert, $confirm } = useAlertStore();

const loadingStore = usePageLoadingStore()
const { $interests, $corpState, $gbNameKR, $toast, $number, $pageListBoardNo, $yyyymmddHHmmss, $yyyymmdd, $yyyymm, $gb, $bizNum, $userGbKR } = getCurrentInstance().appContext.config.globalProperties;

const props = defineProps({
  user: {
    type: Object,
    default: () => ({}),
  },
});

const user = computed(() => props.user || {});

const searchOpen = ref(true);

const resultUserCount = ref({}); // 매칭 내역 수
const userMatchingList = ref([]);

const userMatchingResumeModal = ref(null);  // 기본 이력서
const proposalContentModal = ref(null);     // 채용 이력서

const interests = ref($interests);
const corpState = ref($corpState);

const interestsListRef4 = ref(null);
const stateGbsListRef4 = ref(null);
const matchingGbListRef4 = ref(null);

const currentPage = ref(1);
const pageSize = ref(10);
const totalPages = ref(0);
const totalCount = ref(0);

const searchInput4 = ref({ // 채용 진행 현황 tab 검색조건
  stateGbsList: ['01', '02', '03', '04', '05', '06', '07', '08'],
  interestsList: ['설계','장비','소재','제조공정','패키지','테스트','SW','기타'],
  matchingGbList: ['01','02'],
  searchType: 'corpName', // corpName 기업명
  searchInput: '',
  searchDurationType: 'all',
  startYmd: '',
  endYmd: '',
});

// 1. 매칭 내역 조회
const retrieveUserMatchHistoryList = async () => {
  let paramObj = {
    userId: user.value.userId,  // userId 추가
    searchStateGbs: _.map(searchInput4.value.stateGbsList).join(','),
    searchInterests: _.map(searchInput4.value.interestsList).join(','),
    searchMatchingGb: _.map(searchInput4.value.matchingGbList).join(','),
    searchType: searchInput4.value.searchType,
    searchInput: searchInput4.value.searchInput,
    startYmd: searchInput4.value.searchDurationType === 'all' ? '' : searchInput4.value.startYmd,
    endYmd: searchInput4.value.searchDurationType === 'all' ? '' : searchInput4.value.endYmd,
    pageNumber: currentPage.value,
    size: pageSize.value,
  }
  loadingStore.loading = true;
  //loaded.value = false;
  adminMatchingService.retrieveUserMatchingList(paramObj)
      .then( async (res) => {
        loadingStore.loading = false;
        await retrieveUserCount();
        //loaded.value = true;
        //console.log(res);
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          userMatchingList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
        } else {
        }
      }).catch( (res) =>  {
    console.log(res);
    loadingStore.loading = false;
    //loaded.value = true;
  });
}

// 2. 개인별 매칭 내역 전체 COUNT 조회
const retrieveUserCount = () => {
  adminMatchingService.retrieveMatchingUserTotalCount(user.value.userId)
      .then( (res) => {
        if(res.data.code.toLowerCase() === 'success') {
          resultUserCount.value = res.data.result;
        } else {
        }
      }).catch( (res) => {
  });
}

// 3. 채용 상태 변경
const changeUserState = (matchingGb, userId, stateGb, propId, corpId, resumeId) => {
  if(matchingGb === '01') {  // 받은 채용 제안
    changeUserPropState(userId, propId, stateGb);
  } else if(matchingGb === '02') {  // 입사 지원 현황(인재 채용)
    changeUserResState(resumeId, corpId, stateGb)
  }
}

// 3-1. 인재 채용 상태 변경
const changeUserResState = async (resumeId, corpId, stateGb) => {
  let confirmMsg;
  let confirmBtn;

  if ( stateGb === "03" ) {
    confirmMsg = ["채용 제안을 수락하시겠습니까?", "‘매칭완료’로 상태가 변경됩니다."];
    confirmBtn = "제안 수락";
  } else if ( stateGb === "04" ) {
    confirmMsg = ["채용 제안을 거절하시겠습니까?", "‘매칭중단’으로 상태가 변경됩니다."];
    confirmBtn = "제안 거절";
  }

  const ok = await $confirm(confirmMsg, confirmBtn);

  if(!ok) {
    return -1;
  } else {
    let paramObj2 = {
      resumeId: resumeId,
      corpId: corpId,
      resStateGb: stateGb,
    }
    mypageProposalService.changeResumeCorporationState(paramObj2)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            $alert("변경하였습니다.");
            retrieveUserMatchHistoryList();
            // 매칭 상태값 업데이트
            retrieveMatchingUpdate();
          } else {
            console.log(res);
          }
        }).catch( (res) =>  {
      loadingStore.loading = false;
      console.log(res);
    });
  }
}

// 3-2. 채용 제안 상태 변경(받은 채용)
const changeUserPropState = async (userId, propId, stateGb) => {
  let confirmMsg;
  let confirmBtn;

  if( stateGb === '03' ) {
    confirmMsg = ["채용 제안을 수락하시겠습니까?", "'매칭완료'로 상태가 변경됩니다."];
    confirmBtn = "제안 수락";
  } else if ( stateGb === '04' ) {
    confirmMsg = ["채용 제안을 거절하시겠습니까?", "'매칭중단'으로 상태가 변경됩니다."];
    confirmBtn = "제안 거절";
  }

  const ok = await $confirm(confirmMsg, confirmBtn);
  if(!ok) {
    return false;
  } else {
    let paramObj = {
      propId: propId,
      userId: userId,
      propStateGb: stateGb
    };
    //console.log(paramObj);

    loadingStore.loading = true;
    mypageProposalService.changeProposalUserState(paramObj)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            $alert("변경하였습니다.");
            retrieveUserMatchHistoryList();
            // 매칭 상태 값 업데이트
            retrieveMatchingUpdate();
          } else {
            console.log(res);
          }
        }).catch( (res) => {
      loadingStore.loading = false;
      console.log(res);
    });
  }
}

// 6. 채용 이력서 보기
const showMatchingResumeModal = (resumeId) => {
  userMatchingResumeModal.value.init(false);
  userMatchingResumeModal.value.retrieveUserMatchingResumeDetail(resumeId, 0);
  userMatchingResumeModal.value.show();
}

// 7. 채용 제안서 보기
const showProposalContentModal = async (propId) => {
  proposalContentModal.value.retrieveProposalContent(propId);
  await proposalContentModal.value.show();
};

// 검색조건 - 인재 채용, 채용 제안. 채용 진행 현황 tab
const GroupMatching4 = ref([
  { label:'입사 지원', value: '02' },
  { label:'받은 채용', value: '01' },
]);

// 검색조건 - 날짜검색기준 (all 모든 기간, term 기간 검색). 재직자 가입 현황 tab
const searchDurationTypeGroup = ref([
  { label:'모든 기간', value: 'all' },
  { label:'기간 검색', value: 'term' },
]);

// 검색조건 - 페이지 크기, 재직자 가입 현황 tab, 채용 진행 현황 tab
const pageSizeGroup = ref([
  { label:'10개씩 보기', value: '10' },
  { label:'30개씩 보기', value: '30' },
  { label:'50개씩 보기', value: '50' },
  { label:'100개씩 보기', value: '100' },
]);

// 페이지 선택
const onSelectPage = (pageNo) => {
  currentPage.value = pageNo;
  retrieveUserMatchHistoryList();
}

// 검색조건 - 페이지 크기 변경 이벤트
const onSelectPageSize = (option) => {
  pageSize.value = option.value;
  currentPage.value = 1;
  retrieveUserMatchHistoryList();
}

// 검색조건 - '초기화' 버튼
const clearSearchInput = () => {
  searchInput4.value = {
    stateGbsList: ['01', '02', '03', '04', '05', '06', '07', '08'],
    interestsList: ['설계','장비','소재','제조공정','패키지','테스트','SW','기타'],
    matchingGb: ['01','02'],
    searchInput: '',
    searchDurationType: 'all',
    startYmd: '',
    endYmd: '',
  }
  stateGbsListRef4.value.initOptions();
  interestsListRef4.value.initOptions();
  matchingGbListRef4.value.initOptions();
}

// 검색조건 - '검색' 버튼
const onClickSearch = () => {
  currentPage.value = 1;
  retrieveUserMatchHistoryList();
}


onMounted(() => {
  retrieveUserMatchHistoryList();
})
</script>
<template>
  <!-- s: 전체 현황 -->
  <div class="table-form">
    <table class="horizontal all-border">
      <tr class="tr-focus-top tr-focus-side">
        <th rowspan="2">전체 현황</th>
        <th class="total">전체</th>
        <th class="th-blue">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','01') }}</th>
        <th class="th-blue">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','02') }}</th>
        <th class="th-blue">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','03') }}</th>
        <th class="th-blue">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','04') }}</th>
        <th class="th-red">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','05') }}</th>
        <th class="th-red">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','06') }}</th>
        <th>{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','07') }}</th>
        <th>{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','08') }}</th>
      </tr>
      <tr class="tr-focus-side tr-focus-bottom">
        <td>{{ resultUserCount.totalState }}</td>
        <td>{{ resultUserCount.totalState01 }}</td>
        <td>{{ resultUserCount.totalState02 }}</td>
        <td>{{ resultUserCount.totalState03 }}</td>
        <td>{{ resultUserCount.totalState04 }}</td>
        <td>{{ resultUserCount.totalState05 }}</td>
        <td>{{ resultUserCount.totalState06 }}</td>
        <td>{{ resultUserCount.totalState07 }}</td>
        <td>{{ resultUserCount.totalState08 }}</td>
      </tr>
      <tr>
        <th rowspan="2">인재 채용 현황</th>
        <th class="total">전체</th>
        <th class="th-blue">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','01') }}</th>
        <th class="th-blue">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','02') }}</th>
        <th class="th-blue">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','03') }}</th>
        <th class="th-blue">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','04') }}</th>
        <th class="th-red">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','05') }}</th>
        <th class="th-red">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','06') }}</th>
        <th>{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','07') }}</th>
        <th>{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','08') }}</th>
      </tr>
      <tr>
        <td>{{ resultUserCount.totalResState }}</td>
        <td>{{ resultUserCount.resState01 }}</td>
        <td>{{ resultUserCount.resState02 }}</td>
        <td>{{ resultUserCount.resState03 }}</td>
        <td>{{ resultUserCount.resState04 }}</td>
        <td>{{ resultUserCount.resState05 }}</td>
        <td>{{ resultUserCount.resState06 }}</td>
        <td>{{ resultUserCount.resState07 }}</td>
        <td>{{ resultUserCount.resState08 }}</td>
      </tr>
      <tr>
        <th rowspan="2">채용 제안 현황</th>
        <th class="total">전체</th>
        <th class="th-blue">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','01') }}</th>
        <th class="th-blue">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','02') }}</th>
        <th class="th-blue">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','03') }}</th>
        <th class="th-blue">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','04') }}</th>
        <th class="th-red">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','05') }}</th>
        <th class="th-red">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','06') }}</th>
        <th>{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','07') }}</th>
        <th>{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','08') }}</th>
      </tr>
      <tr>
        <td>{{ resultUserCount.totalPropState }}</td>
        <td>{{ resultUserCount.propState01 }}</td>
        <td>{{ resultUserCount.propState02 }}</td>
        <td>{{ resultUserCount.propState03 }}</td>
        <td>{{ resultUserCount.propState04 }}</td>
        <td>{{ resultUserCount.propState05 }}</td>
        <td>{{ resultUserCount.propState06 }}</td>
        <td>{{ resultUserCount.propState07 }}</td>
        <td>{{ resultUserCount.propState08 }}</td>
      </tr>
    </table>
  </div>
  <!-- e: 전체 현황 -->
  <br>
  <!-- s: 검색 -->
  <div class="filter-wrap" :class="{'open': searchOpen}">
    <p @click="searchOpen = !searchOpen">검색</p>
    <div class="filter">
      <dl>
        <dt style="display:block;"><span>상태</span><br/><small style="font-weight: normal;">복수 선택 가능</small></dt>
        <dd>
          <KSACheckBoxGroup
              ref="stateGbsListRef4"
              className="mr-md"
              name="stateGbsList"
              v-model="searchInput4.stateGbsList"
              :options="corpState" />
        </dd>
      </dl>
      <dl>
        <dt style="display:block;"><span>관심 카테고리</span><br/><small style="font-weight: normal;">복수 선택 가능</small></dt>
        <dd>
          <KSACheckBoxGroup
              ref="interestsListRef4"
              className="mr-md"
              name="interestsList"
              v-model="searchInput4.interestsList"
              :options="interests" />
        </dd>
      </dl>
      <dl>
        <dt>경로 구분</dt>
        <dd>
          <KSACheckBoxGroup
              ref="matchingGbListRef4"
              className="mr-md"
              name="matchingGbList"
              v-model="searchInput4.matchingGbList"
              :options="GroupMatching4" />
        </dd>
      </dl>
      <dl>
        <dt>채용제안일</dt>
        <dd class="text-box">
          <div class="grid">
            <template v-for="group in searchDurationTypeGroup" key="item.value" >
              <KSARadioButton class="mr-md" name="searchDurationGb3" :label="group.label" v-model="searchInput4.searchDurationType" :value="group.value" />
            </template>
            <div style="display: inline-block;" v-show="searchInput4.searchDurationType !== 'all'">
              <KSADatepickerTerms
                  :startDate="searchInput4.startYmd"
                  :endDate="searchInput4.endYmd"
                  @update:startDate="(value)=> searchInput4.startYmd = value"
                  @update:endDate="(value)=> searchInput4.endYmd = value"
              />
            </div>
          </div>
        </dd>
      </dl>
      <dl>
        <dt>기업명</dt>
        <dd>
          <KSAInput class="text-box" v-model="searchInput4.searchInput" placeholder="기업명을 입력해 주세요." />
        </dd>
      </dl>
      <div class="btn-wrap">
        <KSASecondaryButton class="gray_button" text="초기화" @click="clearSearchInput" />
        <KSAPrimaryButton text="검색" @click="onClickSearch" />
      </div>
    </div>
  </div>
  <!-- e: 검색 -->
  <div class="list-top">
    <p>전체 <span>{{ $number(totalCount)}}</span>건</p>
    <div>
      <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
    </div>
  </div>
  <div class="table-form">
    <table class="horizontal" v-if="userMatchingList !== null">
      <tr>
        <th>NO</th>
        <th>채용 제안일</th>
        <th>경로 구분</th>
        <th>기업명</th>
        <th>제안 마스터명</th>
        <th>관심 카테고리</th>
        <th>이력서 보기</th>
        <th>채용 제안서 보기</th>
        <th>상태</th>
        <th>상태 변경</th>
      </tr>
      <tr v-for="userMatching in userMatchingList">
        <td>{{ userMatching.boardNo }}</td>
        <td>{{ $yyyymmddHHmmss(userMatching.createDate) }}</td>
        <td>
          <span v-if="userMatching.matchingGb === '01'">받은 채용</span>
          <span v-else style="display:block;"><span>입사 지원</span><br/><span>(인재 채용)</span></span>
        </td>
        <td class="link text"><RouterLink :to="{name:'MatchingCorpDetail', params:{id: userMatching.corpId}}">{{ userMatching.corpName }}</RouterLink></td>
        <td class="link text"><RouterLink :to="{name:'MemberDetail', params:{id: userMatching.corpUserId}}">{{ userMatching.corpUserName }}</RouterLink></td>
        <td>{{ userMatching.interests }}</td>
        <td class="link text">
          <span v-if="userMatching.resumeId !== 0" @click="showMatchingResumeModal(userMatching.resumeId)">이력서 보기</span>
          <span v-else>-</span>
        </td>
        <td>
          <span v-if="userMatching.propId !== 0" @click="showProposalContentModal(userMatching.propId)" class="link text">제안서 보기</span>
          <span v-else>-</span>
        </td>
        <td>{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB', userMatching.stateGb) }}</td>
        <!-- 01 매칭중 02 제안취소 03 매칭완료 04 매칭중단 05 전형진행중 06 전형중단 07 합격 08 불합격 -->
        <td>
          <!-- 01 매칭중 02 제안취소 03 매칭완료 04 매칭중단 05 전형진행중 06 전형중단 07 합격 08 불합격 -->
          <span v-if="userMatching.stateGb === '01'" data-title="제안 수락/거절 : ">
            <KSASecondaryButton text="제안수락" @click="changeUserState(userMatching.matchingGb, userMatching.userId, '03', userMatching.propId, userMatching.corpId, userMatching.resumeId)" class="blue_button md_btn"/>
            <KSASecondaryButton text="제안거절" @click="changeUserState(userMatching.matchingGb, userMatching.userId, '04', userMatching.propId, userMatching.corpId, userMatching.resumeId)" class="red_button md_btn"/>
          </span>
          <span v-else-if="userMatching.stateGb === '03'" data-title="제안 수락/거절 : ">
            <KSASecondaryButton text="제안거절" @click="changeUserState(userMatching.matchingGb, userMatching.userId, '04', userMatching.propId, userMatching.corpId, userMatching.resumeId)" class="red_button md_btn"/>
          </span>
          <span v-else-if="userMatching.stateGb === '04'" data-title="제안 수락/거절 : ">
            <KSASecondaryButton text="제안수락" @click="changeUserState(userMatching.matchingGb, userMatching.userId, '03', userMatching.propId, userMatching.corpId, userMatching.resumeId)" class="blue_button md_btn"/>
          </span>
        </td>
      </tr>
    </table>
  </div>
  <div class="result-none" v-if="userMatchingList.length === 0">
    진행중인 채용 건이 없습니다.
  </div>
  <Paginate
      v-if="userMatchingList.length > 0"
      v-model="currentPage"
      :page-count="totalPages"
      :click-handler="onSelectPage"
  />
  <MypageProposalContentModal ref="proposalContentModal"/>
  <MyPageResumeModal ref="userMatchingResumeModal"/>
</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";
</style>